'use client';
import React from 'react';
import { trackPhoneClick, trackGAdsPhoneCallConversion } from '@/lib/analytics';

interface PhoneLinkProps {
  source: string;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

// Single choke point for every phone CTA: GA4 phone_click + Google Ads call conversion.
export default function PhoneLink({ source, className, style, children }: PhoneLinkProps) {
  return (
    <a
      href="tel:587-990-7769"
      onClick={() => {
        trackPhoneClick(source);
        trackGAdsPhoneCallConversion();
      }}
      className={className}
      style={style}
    >
      {children}
    </a>
  );
}
